import axios from 'axios'
// import store from "../router/index"
import store from '@/store'
import {
  Message
} from 'element-ui'
import router from '../router/index'
// 创建axios 实例
const service = axios.create({
  // baseURL: process.env.baseUrl, // api的base_url
  // baseURL: 'https://dissertation.newacademic.net/api', // api的base_url
  // baseURL:"http://192.168.66.18:8083/api", 
  baseURL: window.location.origin + '/api',
  timeout: 50000 // 请求超时时间
})


service.interceptors.request.use((config) => {
  // 动态设置请求头
  config.headers.common = {
    Authorization: 'Bearer ' + store.getCookie('token')
  }

  if (config.method === 'post') {
    config.data = {
      ...config.data,
      t: Date.parse(new Date())
    }
  } else if (config.method === 'get') {
    config.params = {
      ...config.params,
      t: Date.parse(new Date())
    }
  }
  return config
}, (err) => {
  return Promise.reject(err)
})

service.interceptors.response.use((res) => {
  if (res.data.error_code == 2) {
    window.localStorage.clear()
    window.sessionStorage.clear()
    // console.log('aaa')
    router.push({
      name: "login",
    });
    Message.error({
      type: 'error',
      message: res.data.message + '！请重新登录'
    });
    // this.$message.error(res.data.message + '！请重新登录');


  } else if (res.data.code == 1003 || res.data.code == 1002 || res.data.code == 1001) {
    window.localStorage.clear()
    window.sessionStorage.clear()
    // console.log('aaa')
    router.push({
      name: "login",
    });
    Message.error({
      type: 'error',
      message: res.data.message + '！请重新登录'
    });
  }

  return res
}, (err) => {
  return Promise.reject(err)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js